import { render, staticRenderFns } from "./zDialogoSimNao.vue?vue&type=template&id=cc615bf0&scoped=true&"
import script from "./zDialogoSimNao.vue?vue&type=script&lang=js&"
export * from "./zDialogoSimNao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc615bf0",
  null
  
)

export default component.exports